import template from './uc-milestones-page.html.twig';
import './uc-milestones-page.scss';

Shopware.Component.register('uc-milestones-page', {
    template,

    methods: {
        goToConfig() {
            this.$router.push({ name: 'sellops.ultimate.cart.config' });
        },
    },
});
